import { render, staticRenderFns } from "./Theme2TheFooter.vue?vue&type=template&id=3a6e5ccf&scoped=true&"
import script from "./Theme2TheFooter.vue?vue&type=script&lang=js&"
export * from "./Theme2TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./Theme2TheFooter.vue?vue&type=style&index=0&id=3a6e5ccf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6e5ccf",
  null
  
)

export default component.exports